import React from "react";

import ImageLeft from "../basic/ImageLeft";
import ImageRight from "../basic/ImageRight";

const Policies = (props) => {
  const Media_Object_Group = props?.LeftImage?.content?.Media_Object_Group;
  return (
    <div className="specialize text-center">
      {props?.LeftImage?.content?.Header?.map((head) => {
        return <h1 key={head._uid}> {head?.headline}</h1>;
      })}
      <div className="container-fluid">
        <div className="row">
          {Media_Object_Group?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.Image_Position === "left" ? (
                  <ImageLeft item={item} />
                ) : (
                  <React.Fragment key={index}></React.Fragment>
                )}

                {item.Image_Position === "right" ? (
                  <ImageRight item={item} />
                ) : (
                  <React.Fragment key={index}></React.Fragment>
                )}
                <hr className="solid" />
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Policies;
